import { z } from 'zod';
import { refineColumnName } from '../Refines';
import { FieldSpecSchema } from './Common';

export const DataSourceFieldTypes = [
  'source',
  'alias',
  'sql',
  'literal',
  'join',
] as const;

export const DataSourceFieldSchema = FieldSpecSchema.extend({
  type: z.enum(DataSourceFieldTypes),
  takenNames: z.array(z.string()),
  name: z
    .string({
      required_error: 'Name is required',
    })
    .refine(...refineColumnName),
}).superRefine((data, ctx) => {
  if (data.type === 'source' && !data.from) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must select a source',
      path: ['from'],
    });
  }

  if (data.type === 'alias' && !data.alias) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must select am alias',
      path: ['alias'],
    });
  }

  if (data.name && data.takenNames.includes(data.name)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'This name is already taken',
      path: ['name'],
    });
  }

  if (data.type === 'join' && data.join?.useCSV && !data.join.withCSV?.path) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must enter a path to a CSV file',
      path: ['join', 'withCSV', 'path'],
    });
  }

  if (data.type === 'join' && !data.join?.useCSV && !data.join?.withTable) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must enter a table name',
      path: ['join', 'withTable'],
    });
  }

  if (data.type === 'join' && !data.join?.lhs) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must enter LHS column',
      path: ['join', 'lhs'],
    });
  }

  if (data.type === 'join' && !data.join?.rhs) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must enter RHS column',
      path: ['join', 'rhs'],
    });
  }

  if (data.type === 'join' && !data.join?.select) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must enter field value expression',
      path: ['join', 'select'],
    });
  }

  if (data.type === 'literal' && !data.literal) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must enter a literal value',
      path: ['literal'],
    });
  }

  if (data.type === 'sql' && !data.expr) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'You must enter a SQL expression',
      path: ['expr'],
    });
  }
});

export type DataSourceFieldSchemaValues = z.infer<typeof DataSourceFieldSchema>;
